import { AsYouType, CountryCode } from 'libphonenumber-js/min';

/**
 * Formats a phone number using libphonenumber-js
 */
export const formatPhoneNumber = (
  rawNumber: string,
  countryISO?: string,
): string => {
  const formattedRawNumber =
    rawNumber.charAt(0) === '+' ? rawNumber : `+${rawNumber}`;
  const formatter = new AsYouType(countryISO?.toUpperCase() as CountryCode);
  return formatter.input(formattedRawNumber);
};
